import { render, staticRenderFns } from "./bigWeekly.vue?vue&type=template&id=9ae3aa66&scoped=true"
import script from "./bigWeekly.vue?vue&type=script&lang=js"
export * from "./bigWeekly.vue?vue&type=script&lang=js"
import style0 from "./bigWeekly.vue?vue&type=style&index=0&id=9ae3aa66&prod&scoped=true&lang=css"
import style1 from "./bigWeekly.vue?vue&type=style&index=1&id=9ae3aa66&prod&lang=css"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ae3aa66",
  null
  
)

export default component.exports